// Function to remove Czech diacritics and convert to basic Latin characters
export const removeDiacritics = (str: string): string => {
  const diacriticsMap: Record<string, string> = {
    'Á': 'A',
    'Č': 'C',
    'Ď': 'D',
    'É': 'E',
    'Ě': 'E',
    'Í': 'I',
    'Ň': 'N',
    'Ó': 'O',
    'Ř': 'R',
    'Š': 'S',
    'Ť': 'T',
    'Ú': 'U',
    'Ů': 'U',
    'Ý': 'Y',
    'Ž': 'Z',
  };

  return str.split('').map(char => diacriticsMap[char] || char).join('');
};

// Normalize SPZ: uppercase, remove diacritics, keep only letters and numbers, limit to 9 characters
export const normalizeSpz = (value: string): string => {
  if (!value) return '';

  // Convert to uppercase and remove diacritics
  let normalized = removeDiacritics(value.toUpperCase());

  // Keep only letters and numbers
  normalized = normalized.replace(/[^A-Z0-9]/g, '');

  // Limit to 9 characters after normalization
  return normalized.substring(0, 9);
};